import React from 'react';
import { Button } from '../ui/button.jsx';
import { useOktaAuth } from '@okta/okta-react';

/**
 * CustomAuthButton component for Okta authentication
 * Uses the useOktaAuth hook from @okta/okta-react
 */
const CustomAuthButton = ({ label = 'Sign in with Okta', className = '' }) => {
  const { oktaAuth, authState } = useOktaAuth();

  // If we're still loading authentication state
  if (!authState) {
    return (
      <Button disabled className={className}>
        Loading...
      </Button>
    );
  }

  // If we're already authenticated, don't show the button
  if (authState.isAuthenticated) {
    return null;
  }

  const handleLogin = async () => {
    try {
      // Save current location for redirect after authentication
      localStorage.setItem('okta-app-original-uri', window.location.pathname);
      
      // Debug logging in development
      if (process.env.NODE_ENV === 'development') {
        console.log('Starting authentication with PKCE...');
        console.log('Okta Config:', {
          issuer: oktaAuth.options.issuer || 'Not Set',
          clientId: oktaAuth.options.clientId ? '[HIDDEN]' : 'Not Set',
          redirectUri: oktaAuth.options.redirectUri || 'Not Set',
          pkce: oktaAuth.options.pkce || false,
        });
      }
      
      // Redirect to Okta for authentication
      await oktaAuth.signInWithRedirect();
    } catch (error) {
      console.error('Authentication Error:', error);
    }
  };

  return (
    <div>
      {authState.error && (
        <div className="text-red-600 mb-4 p-3 bg-red-50 border-l-4 border-red-600 rounded">
          <p>{authState.error.message || 'An error occurred during authentication'}</p>
          {process.env.NODE_ENV === 'development' && (
            <div className="mt-2 text-xs">
              <p>Debug Info:</p>
              <p>Origin: {window.location.origin}</p>
              <p>Redirect URI: {oktaAuth.options.redirectUri}</p>
            </div>
          )}
        </div>
      )}
      
      <Button
        onClick={handleLogin}
        className={className}
      >
        {label}
      </Button>
    </div>
  );
};

export default CustomAuthButton;
